import { cn } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';

import { getClasses, getIconSize, getTextClasses } from './lib/getClasses';

/**
 * @param {import('./lib/propTypes').BadgeProps} props
 */

const Badge = (props) => {
  const {
    text,
    size = 'large',
    color = 'neutral',
    variant = 'default',
    isRounded = true,
    icon,
    iconRight,
    className,
    ...rest
  } = props;

  return (
    <div className={cn(getClasses({ text, size, color, variant, isRounded }), className)} {...rest}>
      {icon && <Icon icon={icon} size={getIconSize(size)} color={color} />}
      {typeof text === 'object'
        ? text
        : text && <span className={getTextClasses(size)}>{text}</span>}
      {iconRight && <Icon icon={iconRight} size={getIconSize(size)} color={color} />}
    </div>
  );
};

export default Badge;
